<!--
  Переиспользуемое содержимое PDF-превью документа.
  Используется в модальном окне и в представлении по старой ссылке ?tab=pdf.
-->
<template>
  <div v-if="visible" class="page-layout__pdf">
    <div class="pdf-viewer">
      <div v-if="!document.pdf_url && pdfPendingVisible" class="pdf-placeholder pdf-placeholder--pending">
        <div class="pdf-placeholder__lines" aria-hidden="true">
          <div class="pdf-placeholder__line pdf-placeholder__line--title" />
          <div class="pdf-placeholder__line pdf-placeholder__line--short" />
          <div class="pdf-placeholder__line" />
          <div class="pdf-placeholder__line pdf-placeholder__line--medium" />
          <div class="pdf-placeholder__line" />
          <div class="pdf-placeholder__line pdf-placeholder__line--short" />
          <div class="pdf-placeholder__line" />
          <div class="pdf-placeholder__line pdf-placeholder__line--medium" />
        </div>
        <div class="pdf-placeholder__message">
          <svg class="pdf-placeholder__icon pdf-placeholder__icon--pending" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="8" y="4" width="28" height="38" rx="3" fill="#eff6ff" stroke="#93c5fd" stroke-width="1.5"/>
            <path d="M28 4v10h8" stroke="#93c5fd" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M15 23h14M15 28h18M15 33h10" stroke="#60a5fa" stroke-width="1.5" stroke-linecap="round"/>
            <circle cx="36" cy="36" r="8" fill="#dbeafe" stroke="#60a5fa" stroke-width="1.5"/>
            <path d="M36 31v5l3 2" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <p class="pdf-placeholder__text pdf-placeholder__text--pending">
            PDF формируется в Saby
          </p>
          <p class="pdf-placeholder__hint">
            {{ pdfPollingHint }}
          </p>
        </div>
      </div>
      <div v-else-if="pdfLoadError" class="pdf-placeholder">
        <div class="pdf-placeholder__lines" aria-hidden="true">
          <div class="pdf-placeholder__line pdf-placeholder__line--title" />
          <div class="pdf-placeholder__line pdf-placeholder__line--short" />
          <div class="pdf-placeholder__line" />
          <div class="pdf-placeholder__line pdf-placeholder__line--medium" />
          <div class="pdf-placeholder__line" />
          <div class="pdf-placeholder__line pdf-placeholder__line--short" />
          <div class="pdf-placeholder__line" />
          <div class="pdf-placeholder__line pdf-placeholder__line--medium" />
          <div class="pdf-placeholder__line pdf-placeholder__line--short" />
          <div class="pdf-placeholder__line" />
        </div>
        <div class="pdf-placeholder__message">
          <svg class="pdf-placeholder__icon" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="6" y="2" width="30" height="38" rx="3" fill="#fee2e2" stroke="#fca5a5" stroke-width="1.5"/>
            <path d="M28 2v10h10" stroke="#fca5a5" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M15 22h18M15 27h14M15 32h10" stroke="#fca5a5" stroke-width="1.5" stroke-linecap="round"/>
            <circle cx="36" cy="36" r="10" fill="#fef2f2" stroke="#fca5a5" stroke-width="1.5"/>
            <path d="M32 36h8M36 32v8" stroke="#ef4444" stroke-width="2" stroke-linecap="round" transform="rotate(45 36 36)"/>
          </svg>
          <p class="pdf-placeholder__text">Не удалось загрузить PDF</p>
          <button class="file-link file-link--pdf" @click="$emit('refresh-pdf')">
            Обновить PDF
          </button>
        </div>
      </div>
      <div v-else-if="!document.pdf_url && document.xml_url" class="xml-only">
        <div class="xml-only__body">
          <h3 class="xml-only__title">XML</h3>
          <a
            :href="resolveUrl(document.xml_url)"
            target="_blank"
            class="pdf-toolbar__btn xml-only__link"
          >
            Открыть XML
          </a>
        </div>
      </div>
      <template v-else>
        <PdfLoadingState v-if="isPdfLoading" />
        <div v-else class="pdf-toolbar">
          <a
            v-if="document.xml_url"
            :href="resolveUrl(document.xml_url)"
            target="_blank"
            class="pdf-toolbar__btn"
            title="Открыть XML"
          >
            XML
          </a>
          <button class="pdf-toolbar__btn" title="Открыть в новой вкладке" @click="$emit('open-pdf')">
            Открыть
          </button>
          <button class="pdf-toolbar__btn" title="Скачать PDF" @click="$emit('download-pdf')">
            Скачать
          </button>
        </div>
        <vue-pdf-embed
          v-if="pdfPreviewUrl"
          text-layer
          :source="pdfPreviewUrl"
          class="pdf-viewer__embed"
          @loaded="$emit('pdf-loaded')"
          @loading-failed="$emit('pdf-error', $event)"
        />
      </template>
    </div>
  </div>
  <section v-else class="info-section">
    <div class="card-content empty-state">
      PDF и XML для этого документа пока недоступны.
    </div>
  </section>
</template>

<script>
import VuePdfEmbed from "vue-pdf-embed";
import "vue-pdf-embed/dist/styles/textLayer.css";

import PdfLoadingState from "@/components/Edo/shared/PdfLoadingState.vue";
import { resolveUrl } from "@/utils/fileUtils";

export default {
  name: "EdoDocumentPdfPreview",

  components: {
    PdfLoadingState,
    VuePdfEmbed,
  },

  props: {
    document: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    pdfPendingVisible: {
      type: Boolean,
      default: false,
    },
    pdfPollingHint: {
      type: String,
      default: "",
    },
    isPdfLoading: {
      type: Boolean,
      default: false,
    },
    pdfLoadError: {
      type: Boolean,
      default: false,
    },
    pdfPreviewUrl: {
      type: String,
      default: "",
    },
  },

  emits: ["open-pdf", "download-pdf", "pdf-loaded", "pdf-error", "refresh-pdf"],

  methods: {
    resolveUrl,
  },
};
</script>

<style scoped>
.info-section {
  border-radius: 10px;
  border: 1px solid #e8e8e8;
  overflow: hidden;
  background: #fff;
}

.card-content {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 18px;
}

.empty-state {
  color: #6b7280;
}

.page-layout__pdf {
  position: static;
  max-height: none;
  overflow-y: visible;
}

.pdf-viewer {
  position: relative;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
}

.pdf-toolbar {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
  display: flex;
  gap: 6px;
}

.pdf-toolbar__btn,
a.pdf-toolbar__btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 11px;
  font-size: 12px;
  font-family: inherit;
  font-weight: 500;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(6px);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  color: #374151;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
}

.pdf-toolbar__btn:hover,
a.pdf-toolbar__btn:hover {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}

.pdf-viewer__embed {
  display: block;
  width: 100%;
}

.xml-only {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  background: #f9fafb;
}

.xml-only__body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.xml-only__title {
  margin: 0;
  color: #111827;
  font-size: 18px;
  font-weight: 600;
}

.xml-only__link {
  position: static;
}

.pdf-placeholder {
  position: relative;
  min-height: calc(100vh - 160px);
  overflow: hidden;
  background: #fef9f9;
  border-radius: 6px;
}

.pdf-placeholder--pending {
  background: #f8fbff;
}

.pdf-placeholder__lines {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 32px 40px;
  pointer-events: none;
}

.pdf-placeholder__line {
  height: 12px;
  border-radius: 4px;
  background: #fee2e2;
  width: 100%;
  opacity: 0.5;
}

.pdf-placeholder--pending .pdf-placeholder__line {
  background: #dbeafe;
}

.pdf-placeholder__line--title {
  height: 18px;
  width: 60%;
  opacity: 0.7;
}

.pdf-placeholder__line--medium {
  width: 80%;
}

.pdf-placeholder__line--short {
  width: 45%;
}

.pdf-placeholder__message {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: rgba(254, 249, 249, 0.75);
  backdrop-filter: blur(2px);
}

.pdf-placeholder__icon {
  width: 64px;
  height: 64px;
}

.pdf-placeholder__text {
  margin: 0;
  color: #991b1b;
  font-size: 15px;
  font-weight: 500;
}

.pdf-placeholder__text--pending {
  color: #1d4ed8;
}

.pdf-placeholder__hint {
  max-width: 320px;
  margin: 0;
  color: #475569;
  font-size: 13px;
  line-height: 1.4;
  text-align: center;
}

.file-link {
  display: inline-block;
  padding: 6px 12px;
  border: 1px solid var(--color-blue);
  border-radius: 4px;
  background: none;
  color: var(--color-blue);
  font-family: inherit;
  font-size: 13px;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
}

.file-link--pdf {
  color: #dc2626;
  border-color: #dc2626;
}
</style>
